import { ChevronDown, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CATEGORIES } from "@/lib/api";

const slug = (c) => c.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export function CategoryChips({ cats, testid }) {
  if (!cats?.length) return <span className="text-slate-400">—</span>;
  return <div className="flex flex-wrap gap-1" data-testid={testid}>{cats.map((c) => <span key={c} className="text-[11px] bg-slate-100 text-slate-700 border border-slate-200 rounded px-1.5 py-0.5 whitespace-nowrap">{c}</span>)}</div>;
}

export function CategoryPicker({ value = [], onChange, testid = "category-picker" }) {
  const toggle = (c) => onChange(value.includes(c) ? value.filter((x) => x !== c) : CATEGORIES.filter((x) => x === c || value.includes(x)));
  return (
    <div className="space-y-1.5">
      <Popover modal>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" className="w-full justify-between font-normal" data-testid={testid}>
            <span className="truncate">{value.length ? `${value.length} selected` : "Choose categories"}</span><ChevronDown size={14} className="opacity-60" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-80 p-2" align="start">
          <div className="max-h-72 overflow-y-auto space-y-0.5">
            {CATEGORIES.map((c) => (
              <label key={c} className="flex items-center gap-2 px-2 py-1.5 rounded hover:bg-slate-50 cursor-pointer text-sm" data-testid={`${testid}-opt-${slug(c)}`}>
                <Checkbox checked={value.includes(c)} onCheckedChange={() => toggle(c)} /><span>{c}</span>
              </label>
            ))}
          </div>
        </PopoverContent>
      </Popover>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1">{value.map((c) => (
          <span key={c} className="inline-flex items-center gap-1 text-[11px] bg-blue-50 text-blue-800 border border-blue-200 rounded px-1.5 py-0.5">
            {c}<button type="button" onClick={() => toggle(c)} className="hover:text-red-600" data-testid={`${testid}-remove-${slug(c)}`}><X size={11} /></button>
          </span>))}</div>
      )}
    </div>
  );
}
